// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".response__date[data-v-357725e2]{color:rgba(7,9,25,.5)}.response__content[data-v-357725e2]{margin-left:4rem}.icon-edit[data-v-357725e2]{cursor:pointer}.file-list__feedback[data-v-357725e2]{margin-left:3.5rem}", ""]);
// Exports
module.exports = exports;
